// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"470":"966f7acc","496":"d7b96335","787":"d377519e","968":"476acbf9"}[chunkId] + ".chunk.js";
};